











































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from 'vuex';
import CreditCardModel from '@/models/CreditCard';

const Setup = Vue.extend({
	name: 'CreditCard',
	props: {
		card: {
			type: Object,
			default() {
				return new CreditCardModel();
			},
		},
		selectable: Boolean,
		selected: Boolean,
	},
	computed: {
		...mapGetters(['paymentImage']),
	},
});

@Component
export default class CreditCard extends Setup {
	public card!: CreditCardModel;
	public selectable!: boolean;
	public selected!: boolean;

	// Getters
	public paymentImage!: (type: string) => string;

	public get expiration(): string {
		const expiration = String(this.card.expiration).replace(/[^\d]+/, '');

		return `${expiration.substring(0, 2)}/${expiration.substring(2, 4)}`;
	}

	public get isNewCard() {
		return !this.card.token;
	}
}
